import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  getAllServices,
  getServiceBySlug,
} from "@/api/actions/service-actions";

export const serviceQuery = createQueryKeys("services", {
  // Get all the services
  all: () => ({
    queryKey: [{}],
    queryFn: () =>
      getAllServices({
        populate: "deep,5",
        sort: "publishedAt:DESC",
        pagination: { pageSize: 120 },
      }),
  }),

  // Get particular service data
  get: (slug: string) => {
    const queryParams = {
      filters: { slug: { $eq: slug } },
      populate: "deep,6",
    };

    return {
      queryKey: [queryParams],
      queryFn: () => getServiceBySlug(queryParams),
    };
  },
});
